module.exports = __webpack_public_path__ + "img/economics.d90b0d8f.svg";